import React, { useRef, useState } from 'react';
import { Editor } from '@toast-ui/react-editor';
import '@toast-ui/editor/dist/toastui-editor.css';
import { Spinner } from 'react-bootstrap';
import axiosInstance from '../api/axiosInstance';
import { FaPen, FaTimes } from 'react-icons/fa';

const CommentForm = ({ postId, parentId = null, onSuccess, onCancel, autoFocus = false }) => {
    const editorRef = useRef();
    // const { user } = useAuthStore();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        const content = editorRef.current.getInstance().getMarkdown();
        if (!content.trim()) {
            alert("내용을 입력해주세요.");
            return;
        }

        setLoading(true);
        try {
            // member_id 로직: 로그인 유저는 백엔드에서 처리, 비로그인은 0 (백엔드 로직에 따름)
            // API 명세: member_id는 로그인 시 쿠키 이용, 비로그인 시 백엔드에서 0 처리. 
            // 프론트에서는 별도 전송 필요 없음 (쿠키가 자동으로 감).

            const payload = {
                post_id: postId,
                content: content,
                parent_id: parentId // 부모 댓글 ID (없으면 null 또는 생략)
            };

            const response = await axiosInstance.post('comments', payload);

            if (response.data.status === '0000') {
                editorRef.current.getInstance().setMarkdown(''); // 초기화
                if (onSuccess) onSuccess();
            } else {
                alert(response.data.message || "댓글 등록에 실패했습니다.");
            }
        } catch (error) {
            console.error("Comment submit error:", error);
            alert("오류가 발생했습니다.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="comment-form mt-3">
            <style>
                {`
                    @import url('https://fonts.googleapis.com/css2?family=Gamja+Flower&display=swap');
                    
                    .tape-button {
                        background-color: rgba(255, 255, 255, 0.6);
                        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                        backdrop-filter: blur(2px);
                        border: 1px solid rgba(255,255,255,0.3);
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding: 5px 20px;
                        transition: transform 0.2s;
                        min-width: 110px;
                        height: 45px;
                        user-select: none;
                    }
                    
                    .tape-button:hover {
                        transform: scale(1.05) rotate(0deg) !important;
                        box-shadow: 0 4px 8px rgba(0,0,0,0.15);
                    }

                    .tape-button.submit {
                        transform: rotate(-1deg);
                    }
                    
                    .tape-button.cancel {
                        transform: rotate(1deg);
                    }

                    .tape-icon {
                        font-size: 1.2rem;
                        margin-right: 8px;
                        display: flex;
                        align-items: center;
                    }

                    .tape-text {
                        font-family: 'Gamja Flower', cursive;
                        font-size: 1.3rem;
                        font-weight: bold;
                        padding-top: 2px; /* 폰트 수직 정렬 보정 */
                    }

                    /* 색상 테마 */
                    .tape-button.submit .tape-icon, 
                    .tape-button.submit .tape-text { 
                        color: #1565c0; /* 진한 파란색 */
                    }
                    
                    .tape-button.cancel .tape-icon, 
                    .tape-button.cancel .tape-text { 
                        color: #c62828; /* 진한 빨간색 */
                    }
                `}
            </style>
            <Editor
                initialValue=" "
                previewStyle="vertical"
                height="200px"
                initialEditType="markdown"
                useCommandShortcut={true}
                ref={editorRef}
                autofocus={autoFocus}
                toolbarItems={[
                    ['bold', 'italic', 'strike'],
                    ['quote', 'ul', 'ol'],
                    ['code', 'codeblock']
                ]}
            />
            <div className="d-flex justify-content-end gap-3 mt-3">
                {onCancel && (
                    <div className="tape-button cancel" onClick={!loading ? onCancel : undefined}>
                        <span className="tape-icon"><FaTimes /></span>
                        <span className="tape-text">취소하기</span>
                    </div>
                )}
                <div className="tape-button submit" onClick={!loading ? handleSubmit : undefined}>
                    {loading ? (
                        <Spinner size="sm" animation="border" variant="primary" />
                    ) : (
                        <>
                            <span className="tape-icon"><FaPen /></span>
                            <span className="tape-text">등록하기</span>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CommentForm;
